import classNames from 'classnames';
import { HTMLAttributes, InputHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { VariantProps } from 'tailwind-variants';
import { IsVisible } from '../../../utils';
import { FieldBase, IFieldBaseProps } from '../Base';
import { switchStyles } from './styles';

export interface ISwitchFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
    VariantProps<typeof switchStyles.input> {
  containerProps?: {
    className?: string;
    rest?: Omit<IFieldBaseProps, 'className'>;
  };
  fieldLabel?: string;
  label?: string;
  labelProps?: {
    className?: string;
    variants?: VariantProps<typeof switchStyles.label>;
  };
  switchContainerProps?: {
    className?: string;
    rest?: HTMLAttributes<HTMLDivElement>;
  };
}

export function SwitchField({
  className,
  containerProps,
  design,
  disabled = false,
  fieldLabel,
  label,
  labelProps,
  name,
  onChange,
  placeholder,
  readOnly = false,
  switchContainerProps,
  ...rest
}: ISwitchFieldProps) {
  return (
    <FieldBase
      className={twMerge(
        'flex items-center justify-center px-0 w-full overflow-hidden',
        containerProps?.className,
      )}
      iconPosition="right"
      label={fieldLabel}
      {...containerProps?.rest}
    >
      <div
        className={classNames(
          twMerge(
            'relative flex flex-wrap justify-center w-full',
            switchContainerProps?.className,
          ),
        )}
        {...switchContainerProps?.rest}
      >
        <IsVisible when={!!label}>
          <label
            className={switchStyles.label({
              design: labelProps?.variants?.design,
              disabled: disabled || readOnly,
              errored: !!containerProps?.rest?.error,
              className: labelProps?.className,
            })}
            htmlFor={name}
          >
            {label}
          </label>
        </IsVisible>
        <input
          className={switchStyles.input({
            design,
            errored: !!containerProps?.rest?.error,
            disabled: disabled || readOnly,
            beforeContent: !!placeholder,
            className,
          })}
          disabled={disabled}
          id={name}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          type="checkbox"
          {...rest}
        />
      </div>
    </FieldBase>
  );
}
